import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import {
  QrcodeOutlined,
  EyeOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";

import { Container, Table, Card } from "./styles";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import {
  Pagination,
  Spin,
  Button,
  Modal,
  Image,
  Popover,
  Typography,
  Tooltip,
} from "antd";
import Status from "../../../components/status";
import { Message } from "../../../GlobalStyles";
import { toast } from "react-toastify";
import api from "../../../services/api";
import { MdAdd, MdVisibility } from "react-icons/md";

const { Title, Paragraph, Text } = Typography;

const Pagamentos = () => {
  const navigate = useNavigate();
  const [payments, setPayments] = useState([]);
  const [totalValue, setTotalValue] = useState(0);
  const [paymentsTotal, setPaymentsTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [balance, setBalance] = useState(0);
  const [balanceLeads, setBalanceLeads] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    loadPayments(page);
  }, [page]);

  async function loadPayments(page) {
    setIsLoading(true);
    await api
      .get(`/payments?page=${page}`)
      .then((response) => {
        setPayments(response.data.payments);
        setTotalValue(response.data.totalValue);
        setPaymentsTotal(response.data.paymentsTotal);
        setBalance(response.data.balance);
        setBalanceLeads(response.data.balance_leads);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoading(false);
  }

  const infoContent = (
    <div>
      <Paragraph>
        O saldo em sua conta pode ser utilizado para solicitar OS em nossa
        plataforma.
      </Paragraph>
      <Paragraph>
        Efetue deposito via PIX e seu saldo ficará disponivel após confirmação
        do pagamento
      </Paragraph>
    </div>
  );

  const infoContentLead = (
    <div>
      <Paragraph>
        O saldo em sua conta pode ser utilizado para comprar leads na área de
        marketing.
      </Paragraph>
      <Paragraph>
        Efetue deposito via PIX e seu saldo ficará disponivel após confirmação
        do pagamento
      </Paragraph>
    </div>
  );

  return (
    <Container>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h1>Minha Carteira</h1>
        <Button
          type="primary"
          style={{
            borderRadius: 50,
          }}
          onClick={() => navigate("/cliente/adicionar-saldo")}
        >
          <MdAdd size={20} color="#FFF" />
          Adicionar Saldo
        </Button>
      </div>

      {isLoading ? (
        <Spin style={{ marginTop: 50 }} size="large" />
      ) : (
        <>
          <Card style={{ marginBottom: 20 }}>
            <p>Total</p>
            <CountUp
              separator="."
              duration={1}
              end={paymentsTotal}
              separator="."
            />
          </Card>
          <p>
            Saldo disponível para solicitar OS:
            <Popover
              content={infoContent}
              title="Como funciona"
              trigger="click"
            >
              <InfoCircleOutlined
                style={{
                  cursor: "pointer",
                  marginLeft: 10,
                  color: "#001b22",
                  fontSize: 16,
                }}
              />
            </Popover>
          </p>
          <h3>
            <CountUp
              separator="."
              duration={1.5}
              end={balance}
              prefix="R$ "
              separator="."
              decimal=","
              decimals={2}
            />
          </h3>

          <p style={{ marginTop: 15 }}>
            Saldo disponível para comprar leads:
            <Popover
              content={infoContentLead}
              title="Como funciona"
              trigger="click"
            >
              <InfoCircleOutlined
                style={{
                  cursor: "pointer",
                  marginLeft: 10,
                  color: "#001b22",
                  fontSize: 16,
                }}
              />
            </Popover>
          </p>
          <h3>
            <CountUp
              separator="."
              duration={1.5}
              end={balanceLeads}
              prefix="R$ "
              separator="."
              decimal=","
              decimals={2}
            />
          </h3>

          {!!totalValue && (
            <h4 style={{ marginTop: 30, marginBottom: -10 }}>
              {" "}
              {totalValue.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              })}{" "}
              total em pagamentos
            </h4>
          )}
          <div className="orders">
            {paymentsTotal ? (
              <div className="payments-list">
                {payments.map((payment) => (
                  <div className="payment-card" key={payment.id}>
                    <div className="main-info">
                      <strong>
                        {payment.type === "OS"
                          ? `OS: ${payment.order_id}`
                          : payment.type === "LEAD"
                            ? `COMPRA DE LEAD`
                            : "DEPÓSITO"}
                      </strong>
                      <span>Transação</span>
                    </div>

                    <div className="info-item">
                      <label>Valor</label>
                      <span style={{ color: "#008037", fontWeight: "bold" }}>
                        {(payment.value || 0).toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })}
                      </span>
                    </div>

                    <div className="info-item">
                      <label>Método</label>
                      <span style={{ textTransform: "uppercase" }}>
                        {payment.method}
                      </span>
                    </div>

                    <div className="info-item">
                      <label>Status</label>
                      <Status
                        status={payment.status}
                        isPayment={true}
                        style={{
                          fontSize: 10,
                          height: 18,
                          paddingBottom: 2,
                          width: "fit-content",
                        }}
                      />
                    </div>

                    <div className="info-item">
                      <label>Atualização</label>
                      <span>
                        {format(
                          new Date(payment.update_at),
                          "dd/MM/yyyy HH:mm",
                        )}
                      </span>
                    </div>

                    <div className="actions">
                      <Tooltip title="Ver Detalhes">
                        <Button
                          shape="circle"
                          icon={<MdVisibility size={18} />}
                          onClick={() =>
                            navigate(`/cliente/pagamento/${payment.id}`)
                          }
                        />
                      </Tooltip>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div
                style={{
                  background: "#fff",
                  padding: 50,
                  borderRadius: 15,
                  textAlign: "center",
                  border: "1px solid #eee",
                  marginTop: 25,
                }}
              >
                <Message>Nenhum pagamento encontrado.</Message>
              </div>
            )}
          </div>
          <center>
            <Pagination
              style={{ marginTop: 15, justifySelf: "center" }}
              defaultCurrent={page + 1}
              onChange={(page) => {
                setPage(page - 1);
              }}
              total={paymentsTotal}
              pageSize={30}
            />
          </center>
        </>
      )}
      {selectedPayment && (
        <Modal
          title="Detalhes da Transação"
          visible={isModalVisible}
          onOk={handleOk}
          onCancel={handleCancel}
        >
          {selectedPayment.method === "pix" &&
            selectedPayment.status === "pending" && (
              <>
                <p>Scaneie o QR Code para pagar:</p>
                <Image width={200} src={selectedPayment.qr_code} />
              </>
            )}
        </Modal>
      )}
    </Container>
  );
};

export default Pagamentos;
